import { render, staticRenderFns } from "./EmployeeBenefits.vue?vue&type=template&id=4e3a6aec&"
import script from "./EmployeeBenefits.vue?vue&type=script&lang=js&"
export * from "./EmployeeBenefits.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeBenefits.vue?vue&type=style&index=0&id=4e3a6aec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports